import {LatLng} from "../angular/models/service-area.model";

export enum GeofenceLocationType {
  ACCOUNT = 'ACCOUNT',
  DEPOT = 'DEPOT',
  CUSTOMER = 'CUSTOMER'
}

export interface GeofenceZoneCreator {
  id?: string;
  name?: string;
}

export interface GeofenceZone {
  id?: string;
  siteId?: string;
  locationId?: string;
  locationType?: GeofenceLocationType;
  locationName?: string;
  radiusMeters?: number;
  center?: LatLng;
  coordinates?: LatLng[];
  isArchive?: boolean;
  createdAt?: number;
  updatedAt?: number;
  createdBy?: GeofenceZoneCreator;
}

export interface GeofenceZonesQueryParams {
  locationIds?: string[];
  locationTypes?: GeofenceLocationType[];
  limit?: number;
  cursor?: string;
}
